module.exports = __webpack_public_path__ + "img/block_03_img.d7b8193c.png";